import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userSelector } from '@lootboy/lib/selectors';

import useConfiguration from '~/redux/hooks/useConfiguration';
import { languageSelector } from '~/redux/selectors';
import { LOGIN_REQUIRED_PATH } from '~/routes/paths';

export type TUseOfferWallHook =
  | null
  | { pathname: string }
  | { href: string; background: string | undefined; onAccept: () => void };

export const useOfferWallHook = (
  key: 'surveyQuests' | 'diamondDream',
): TUseOfferWallHook => {
  const { _id, isCPXUser } = useSelector(userSelector) || {};
  const offerWallConfig = useConfiguration()[key];
  const language = useSelector(languageSelector);
  return useMemo(() => {
    if (!offerWallConfig?.web) {
      return null;
    }

    if (!_id) {
      return {
        pathname: LOGIN_REQUIRED_PATH,
      };
    }
    const href = offerWallConfig.web
      .replace('{{userId}}', _id)
      .replace('{{lang}}', language || '');
    return {
      background:
        offerWallConfig.image && isCPXUser
          ? offerWallConfig.image
              .replace('{{userId}}', _id || '')
              .replace('{{lang}}', language || '')
          : undefined,
      href,
      onAccept: () => {
        window.open(href, '_blank');
      },
    };
  }, [_id, isCPXUser, language, offerWallConfig]);
};
